import React from 'react';
import classNames from 'classnames/bind';
import { Button } from '@thd-olt-component-react/button';
import { func, string, bool } from 'prop-types';
import styles from './custom-catalog-button.module.scss';

let cx = classNames.bind(styles);

const CustomCatalogButton = ({ onCpoClick, value, title, newDesign }) => {
  return (
    <div className={cx({ 'custom-catalog-button': !newDesign }, { 'new-custom-catalog-button': newDesign })}>
      <Button value={value} onClickCapture={onCpoClick}>
        <span
          className={cx({ 'custom-catalog-button__text': !newDesign },
            { 'new-custom-catalog-button__text': newDesign })}
        >
          {title}
        </span>
      </Button>
    </div>
  );
};

CustomCatalogButton.displayName = 'CustomCatalogButton';

CustomCatalogButton.propTypes = {
  onCpoClick: func,
  value: string,
  title: string.isRequired,
  newDesign: bool,
};

CustomCatalogButton.defaultProps = {
  onCpoClick: () => {},
  value: 'false',
  newDesign: false,
};

export { CustomCatalogButton };
